import { makeRequest } from 'utils/requestLogger';

export default (id, studentID) =>
  makeRequest(
    'get',
    `/api/courses/${id}/get_student_activities/${studentID}`
  ).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/services/courses/getStudentActivities.js